import * as ACTIONS from "@iso/redux/settings/actionTypes";

const initialState = {
  settings: {
    list: [],
    total: 0,
  },
};

function settingsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_SETTINGS_SUCCESS: {
      return {
        ...state,
        ...{ settings: payload },
      };
    }

    default:
      return state;
  }
}

export default settingsReducer;
